import { InputModes, InputTypes } from '@cashier/cashier-model';

const inputModeMap: Partial<Record<InputTypes, InputModes>> = {
  [InputTypes.Text]: InputModes.Text,
  [InputTypes.Regex]: InputModes.Text,
  [InputTypes.Email]: InputModes.Text,
  [InputTypes.Input]: InputModes.Text,
  [InputTypes.Phone]: InputModes.Text,
  [InputTypes.IdentificationNumber]: InputModes.Text,

  [InputTypes.Integer]: InputModes.Numeric,
  [InputTypes.AccountId]: InputModes.Numeric,
  [InputTypes.Cvv]: InputModes.Numeric,
  [InputTypes.CardCvc]: InputModes.Numeric,
  [InputTypes.CreditCardNumber]: InputModes.Numeric,
  [InputTypes.CardNumber]: InputModes.Numeric,
  [InputTypes.CreditCardVisa]: InputModes.Numeric,
  [InputTypes.CreditCardMastercard]: InputModes.Numeric,
  [InputTypes.PayzenPayTmAccountNumber]: InputModes.Numeric,
  [InputTypes.PayzenImpsAccountNumber]: InputModes.Numeric,

  [InputTypes.FiatAmount]: InputModes.Decimal,
  [InputTypes.Amount]: InputModes.Decimal,
  [InputTypes.Number]: InputModes.Decimal,
};

export const InputModeProvider = {
  byInputType(type: InputTypes): InputModes {
    return inputModeMap[type] || InputModes.Text;
  },
};
